import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button2Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM7.75 7.75V3H10.25V7.75H15V10.25H10.25V15H7.75V10.25H3V7.75H7.75Z" />
  </SvgIcon>
);

export default PO28Button2Icon;
